import { Button, ButtonVariants, FormControlSizes, IconName, Tooltip, type CareOrder } from '@talos/kyoko';
import { useMemo } from 'react';
import type { useNetCareOrdersMenuItem } from './MenuItems/useNetCareOrdersMenuItem';

interface CareOrderNetButtonProps {
  selectedCareOrders: CareOrder[];
  netCareOrdersMenu: ReturnType<typeof useNetCareOrdersMenuItem<CareOrder>>;
}

export function CareOrderNetButton({ selectedCareOrders, netCareOrdersMenu }: CareOrderNetButtonProps) {
  const netButtonActionState = useMemo(
    () =>
      netCareOrdersMenu.getButtonActionState({
        selectedCareOrders,
      }),
    [netCareOrdersMenu, selectedCareOrders]
  );

  return (
    <Tooltip tooltip={netButtonActionState.tooltip}>
      <div>
        <Button
          size={FormControlSizes.Small}
          startIcon={IconName.ArrowsReduce}
          variant={ButtonVariants.Positive}
          disabled={netButtonActionState.disabled}
          onClick={netButtonActionState.action}
          data-testid="care-order-net-button"
        >
          Net Orders
        </Button>
      </div>
    </Tooltip>
  );
}
